<button
  *ngIf="(canAccessSaveFilters$ | async) === true"
  [matMenuTriggerFor]="menu"
  data-action="filter-menu-opened"
  mat-stroked-button
>
  <mat-icon>filter_alt</mat-icon>
  {{ 'FRONTEND.SALES_UI.PIPELINE.SAVED_FILTERS' | translate }}
  <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <ng-container *ngIf="savedFilters$ | async as savedFilters">
    <div *ngFor="let filter of savedFilters">
      <div class="saved-filters-wrapper">
        <button
          (click)="applySavedFilter(filter)"
          class="saved-filters"
          data-action-group="filter-group-menu-item"
          mat-button
        >
          {{ filter.filterName }}
        </button>
        <button (click)="deleteSavedFilter(filter.filterName)" data-action-group="filter-group-menu-item" mat-button>
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <button (click)="saveCurrentFilters()" data-action-group="filter-group-menu-item" mat-menu-item>
    <mat-icon>add_circle</mat-icon>
    {{ 'FRONTEND.SALES_UI.PIPELINE.SAVE_CURRENT_FILTERS' | translate }}
  </button>
</mat-menu>
